
import React from 'react';

interface YearProgressProps {
  yearProgress: number;
  yearsPassed: number;
}

const YearProgress: React.FC<YearProgressProps> = ({ yearProgress, yearsPassed }) => {
  if (!yearProgress) return null;
  
  return (
    <div className="mb-6 animate-fade-in">
      <div className="flex justify-between items-center mb-2">
        <p className="text-sm text-muted-foreground">Simulating year {yearsPassed + 1} progress...</p>
        <p className="text-sm font-medium">{yearProgress}%</p>
      </div>
      <div className="h-2 w-full bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
        <div 
          className="h-full bg-gradient-to-r from-bitcoin-primary to-bitcoin-accent rounded-full transition-all duration-300 ease-out"
          style={{ width: `${yearProgress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default YearProgress;
